import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import linkedin from '../../images/linkedin.png';
import twitter from '../../images/twitter.png';
import youtube from '../../images/youtube.png';
import logo from '../../images/logo.png';
import facebook from '../../images/facebook.png';
import instagram from '../../images/instagram.png';
import { FormattedMessage } from 'react-intl';

class Footer extends Component {
  render() {
    return (
      <Navbar className=" colorFooter" expand="lg"> 
        <Container>
          <Nav.Link href="https://www.eutelsat.com/en/satellites.html" target="_blank" className="lienFooter"><FormattedMessage id="footerSatellites" /></Nav.Link>
          <Nav.Link href="https://www.eutelsat.com/en/contact-us.html" target="_blank" className="lienFooter"><FormattedMessage id="footerReserveCapacity" /></Nav.Link>
          <Nav.Link href="https://www.eutelsat.com/en/privacy-policy.html" target="_blank" className="lienFooter"><FormattedMessage id="footerPrivacy" /></Nav.Link>
          <Nav.Link href="https://www.eutelsat.com/en/cookie-policy.html" target="_blank" className="lienFooter"><FormattedMessage id="footerCookiePolicy" /></Nav.Link>
          <Nav.Link href="https://www.eutelsat.com/en/cookie-management.html" target="_blank" className="lienFooter"><FormattedMessage id="footerCookieManagement" /></Nav.Link>
          <Nav.Link href="https://www.eutelsat.com/en/legal.html" target="_blank" className="lienFooter"><FormattedMessage id="footerLegal" /></Nav.Link>
          <Nav.Link href="https://www.linkedin.com/company/eutelsat" target="_blank" className="lienFooter"><img src={linkedin} alt="Logo linkedin" /></Nav.Link>
          <Nav.Link href="https://twitter.com/Eutelsat_Group" target="_blank" className="lienFooter"><img src={twitter} alt="Logo twitter" /></Nav.Link>
          <Nav.Link href="https://www.youtube.com/user/eutelsatvideo" target="_blank" className="lienFooter"><img src={youtube} alt="Logo youtube" /></Nav.Link>
          <Nav.Link href="https://www.flickr.com/photos/eutelsat_communications/" target="_blank" className="lienFooter"><img src={logo} alt="Logo" /></Nav.Link>
          <Nav.Link href="https://www.facebook.com/Eutelsat.SA" target="_blank" className="lienFooter"><img src={facebook} alt="Logo facebook" /></Nav.Link>
          <Nav.Link href="https://www.instagram.com/eutelsatgroup/" target="_blank" className="lienFooter"><img src={instagram} alt="Logo instagram" /></Nav.Link>
          <Nav.Link href="#" target="_blank" className="lienFooter">Eutelsat © 2023</Nav.Link>
        </Container>
      </Navbar>
    );
  }
}

export default Footer;